import { Switch } from 'antd';
import React, { FC } from 'react';
import styled from 'styled-components';
import { confirm } from 'components/atoms/modal';
import { useTranslate, useTranslation } from 'hooks/use-translation';
import { Description, Section, Title } from './styles';

const SwitchWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing-03);
`;

const ContentItems = styled.ul``;

const ConfirmationContentWrapper = styled.div`
  ${ContentItems} {
    margin-bottom: var(--spacing-04);
  }
`;

const SectionWrapper = styled(Section)`
  padding-top: 0;
  padding-bottom: var(--spacing-04);
`;

const content = (
  headingText: string,
  items: string[],
  confirmationText: string,
) => (
  <ConfirmationContentWrapper>
    <span>{headingText}</span>
    <ContentItems>
      {items.map((item) => (
        <li>{item}</li>
      ))}
    </ContentItems>
    <span>{confirmationText}</span>
  </ConfirmationContentWrapper>
);

interface Props {
  enabled: boolean;
  onStateChange: (value: boolean) => void;
}

export const EnableAccounting: FC<Props> = ({ enabled, onStateChange }) => {
  const translate = useTranslate();
  const disableButtonText = useTranslation('disable');
  const disableTitle = useTranslation(
    'settings.financials.disable_confirm.title',
  );
  const disableHeaderText = useTranslation(
    'settings.financials.disable_confirm.message_head',
  );
  const disableTextItems = [
    useTranslation('settings.financials.disable_confirm.message_item_1'),
    useTranslation('settings.financials.disable_confirm.message_item_2'),
    useTranslation('settings.financials.disable_confirm.message_item_3'),
  ];
  const disableConfirmationText = useTranslation(
    'settings.financials.disable_confirm.confirmation',
  );

  const onSwitchChange = (checked) => {
    if (checked) {
      onStateChange(checked);
    } else {
      confirm({
        okType: 'danger',
        okText: disableButtonText,
        title: disableTitle,
        closable: true,
        content: content(
          disableHeaderText,
          disableTextItems,
          disableConfirmationText,
        ),
        onOk: () => {
          onStateChange(checked);
        },
      });
    }
  };

  return (
    <SectionWrapper>
      <Title>{translate('settings.financials.project_accounting.title')}</Title>
      <Description>
        {translate('settings.financials.project_accounting.description')}
      </Description>

      <SwitchWrapper>
        <Switch checked={enabled} onChange={onSwitchChange} size="small" />
        <div>{translate('settings.financials.project_accounting.enabled')}</div>
      </SwitchWrapper>
    </SectionWrapper>
  );
};
